import { AgentStatusResponse } from '../types/AgentStatusResponse';
import { FleetAgent } from '../types/FleetAgent';
import { RequestServerConfiguration } from '../types/RequestServerConfiguration';
import { ExtendedInfo, Server } from '../types/event/server';
import OAuthClient from './oauth.client';

class ServerManagerClient {
  url = process.env.REACT_APP_SM_URL;
  oauth: OAuthClient;

  constructor() {
    this.oauth = new OAuthClient();
  }

  async getServers(): Promise<Server[]> {
    const response = await this.oauth.fetch(`${this.url}/servers`)
      .then((response) => {
        if (!response.ok)
          throw new Error("Failed to fetch servers");

        return response;
      })
      .catch((err) => {
        console.error(err);
        return null;
      });

    if (!response) return [];
    return await response?.json() as Server[];
  }

  async getExtendedInfo(server: Server): Promise<ExtendedInfo | undefined> {
    const response = await this.oauth.fetch(`${this.url}/server/status/extended/${server.taskArn}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch server extended info");
        } else {
          return response;
        }
      })
      .catch((err) => {
        console.error(err);
        return null;
      });

    if (!response) return undefined;
    const responseJson = await response?.json();
    return responseJson as ExtendedInfo;
  }

  async chat(server: Server, message: string): Promise<void> {
   await fetch(`http://${server.taskPublicIP}:${server.port}/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: message,
    })
      .then((response) => {
        if (!response.ok) {
          console.error("Failed to send chat message", response);
          throw new Error("Failed to send chat message");
        }
      })
      .catch((err) => {
        throw new Error("Error sending chat message ", err);
      });  
  }

  async getFleetAgents(): Promise<FleetAgent[]> {
    const response = await this.oauth.fetch(`${this.url}/fleet`)
      .then((response) => {
        if (!response.ok)
          throw new Error("Failed to fetch fleet agents");

        return response;
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
    
    if (!response) return [];
    return await response?.json() as FleetAgent[];
  }

  async stop(arn: string) : Promise<void> {
    await this.oauth.fetch(`${this.url}/server/stop`, "POST", JSON.stringify({ taskArn: arn }));
  }

  async agentStatus(server: Server) : Promise<AgentStatusResponse> {
    const response = await this.oauth.fetch(`${this.url}/agent/status/${server.taskArn}`, "GET");

    const responseJson = await response?.json();
    return responseJson.Message as AgentStatusResponse;
  }

  async request(config: RequestServerConfiguration) : Promise<Response> {
    return await this.oauth.fetch(`${this.url}/request`, "POST", JSON.stringify(config));
  }
}

export default ServerManagerClient;
